import React, { useState } from "react";

import styles from "./TopBar.module.css";
import { Icon } from "../Icon";
import { Cart } from "./navigationCart/Cart";
import classNames from "classnames";
import { useCartSelector } from "../../redux/storeCart";
import { SearchedProducts } from "./SearchedProducts";
import { StyledInput } from "../StyledInput";

export const TopBar = () => {
	const shoppingCart = useCartSelector((state) => state.shoppingCart);

	const [searchIsFocused, setSearchIsFocused] = useState(false);
	const [searchedText, setSearchedText] = useState("");

	const inputSearchChange = (searchText: string) => {
		setSearchIsFocused(true);
		setSearchedText(searchText);
	};

	return (
		<div className={styles.topBar}>
			<a href="/">
				<Icon kind="shop" />
			</a>

			<div className={styles.search}>
				<StyledInput
					kind="primary"
					type={"text"}
					onChange={(input) => {
						inputSearchChange(input.currentTarget.value);
					}}
					value={searchedText}
					placeholder="search"
					onClick={() => setSearchIsFocused(true)}
				></StyledInput>
				{searchIsFocused && (
					<div className={styles.searchOverlay}>
						<SearchedProducts
							search={searchedText}
							callback={() => setSearchIsFocused(false)}
						/>
					</div>
				)}
			</div>

			<a href="/help-center" className={styles.icon}>
				<Icon kind="help" />
				<span>Help</span>
			</a>

			<div className={classNames(styles.icon, styles.cardInfo)}>
				<a href="/cart">
					<Icon kind="cart" />
				</a>
				<span>{shoppingCart.length}</span>
				<div className={styles.cartOverlay}>
					{shoppingCart.length !== 0 ? (
						<Cart cartItems={shoppingCart} />
					) : (
						<div className={styles.emptyCard}>
							Shipping cart is empty
						</div>
					)}
				</div>
			</div>

			<a href="/account" className={styles.icon}>
				<Icon kind="account" />
				<span>Account</span>
			</a>
		</div>
	);
};
